import { customWishList } from './wish-list-de.i18n';

export const de = {
  customWishList: customWishList,
};
